import script from "./MoveEquipmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveEquipmentModal.vue?vue&type=script&setup=true&lang=js"

import "./MoveEquipmentModal.vue?vue&type=style&index=0&id=229dce0a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229dce0a"]])

export default __exports__